import React from 'react';
import { useSelector } from 'react-redux';

export default function useLoginModuleSelector() {
  const LoginGridData = useSelector((state) => state.LoginModule.login_grid?.log_inEntities) || []; // Login Grid Data
  const UserProfileData = useSelector((state) => state.LoginModule.user_profile) || [];
  const RecommendedBankData = useSelector((state) => state.LoginModule.recommended_bank) || [];
  // console.log('RecommendedBank2222', RecommendedBankData);
  return {
    LoginGridData,
    UserProfileData,
    RecommendedBankData
  };
}
